module.exports = __webpack_public_path__ + "07_face.031e8794.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer1/07_face.png
// module id = VB17
// module chunks = 0